function computeButtonState(meta) {
  var qty = Number(meta && meta.qty) || 0;
  if (qty > 0) {
    return { state: 'add', preorder: false, disabled: false };
  }
  if (meta.mfrAvailable === true) {
    return { state: 'preorder', preorder: true, disabled: false };
  }
  if (meta.mfrAvailable === false) {
    return { state: 'sold_out', preorder: false, disabled: true };
  }
  // mfrAvailable == null → kein Hersteller-Match → heutiges Verhalten
  if (meta.management === 'shopify' && meta.policy === 'continue') {
    return { state: 'preorder', preorder: true, disabled: false };
  }
  return { state: 'sold_out', preorder: false, disabled: true };
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { computeButtonState };
}
if (typeof window !== 'undefined') {
  window.computeButtonState = computeButtonState;
}
